import AnimatedBackground from "./animated-background"
export default function Header({ children }) {

	return (
		<header className="relative">
			{/* <AnimatedBackground /> */}
			<h1 className="relative z-10 text-[#f7f8f8] py-8 my-16 sm:my-24 text-2xl leading-[1.2] sm:text-5xl sm:leading-[1.2] tracking-tight font-semibold animate-unblur-2 max-w-3xl">
				{children}
			</h1>
		</header>
	)
}
